<template>
  <b-modal
    id="chat-shortcut-model"
    cancel-variant="outline-secondary"
    :ok-title="$t('button.saveChanges')"
    :cancel-title="$t('button.close')"
    :hide-footer="true"
    centered
    no-close-on-backdrop
    :title="$t('chat.shortcut.title')"
    @ok="handleOk"
  >
    <validation-observer ref="assignOperatorForm" #default="{ invalid }">
      <!-- form -->
      <div class="d-flex flex-row mb-1">
        <div
          class="d-flex justify-content-between align-items-center px-2 w-100"
        >
          <h5>{{ $t("chat.shortcut.exitInput") }}</h5>
          <div
            class="border rounded w-25 d-flex justify-content-center"
            style="padding-top: 8px; padding-bottom: 8px"
          >
            <h5 class="my-auto">F2</h5>
          </div>
        </div>
      </div>
      <div class="d-flex flex-row mb-1">
        <div
          class="d-flex justify-content-between align-items-center px-2 w-100"
        >
          <h5>{{ $t("chat.shortcut.activateInput") }}</h5>
          <div
            class="border rounded w-25 d-flex justify-content-center"
            style="padding-top: 8px; padding-bottom: 8px"
          >
            <h5 class="my-auto">Shift + R</h5>
          </div>
        </div>
      </div>
      <div class="d-flex flex-row mb-1">
        <div
          class="d-flex justify-content-between align-items-center px-2 w-100"
        >
          <h5>{{ $t("permission.close-conversation") }}</h5>
          <div
            class="border rounded w-25 d-flex justify-content-center"
            style="padding-top: 8px; padding-bottom: 8px"
          >
            <h5 class="my-auto">Ctrl + F2</h5>
          </div>
        </div>
      </div>
      <div class="d-flex flex-row mb-1">
        <div
          class="d-flex justify-content-between align-items-center px-2 w-100"
        >
          <h5>{{ $t("chat.shortcut.turnNewLine") }}</h5>
          <div
            class="border rounded w-25 d-flex justify-content-center"
            style="padding-top: 8px; padding-bottom: 8px"
          >
            <h5 class="my-auto">Shift + Enter</h5>
          </div>
        </div>
      </div>
    </validation-observer>
  </b-modal>
</template>

<script>
import {
  BModal,
  BSpinner,
  BFormGroup,
  BBadge,
  BFormCheckbox,
} from "bootstrap-vue";
import NInput from "@/components/NInput";
import Repository from "@/repositories/RepositoryFactory";
import NFormConfirmation from "@/components/NFormConfirmation";
import NAsyncSingleSelect from "@/components/NAsyncSingleSelect.vue";
import useJwt from "@/auth/jwt/useJwt";

const ChatChannelRepository = Repository.get("chatChannel");

export default {
  components: {
    BModal,
    BSpinner,
    BFormGroup,
    BBadge,
    NFormConfirmation,
    NInput,
    NAsyncSingleSelect,
    BFormCheckbox,
  },
  computed: {
    userData: function () {
      return this.$store.state.profile.email || this.$store.state.profile.phone  
        ? this.$store.state.profile
        : JSON.parse(
            localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName)
          );
    },
  },
  data() {
    return {
      loading: false,
      user: "",
      data: {
        token: "",
        userId: "",
      },
      key: 1,
    };
  },
  methods: {
    show() {
      this.$bvModal.show("chat-shortcut-model");
    },
    hide() {
      this.$bvModal.hide("chat-shortcut-model");
    },
    handleOk(bvModal) {
      bvModal.preventDefault();
      if (this.loading) {
        return;
      }

      this.$refs.assignOperatorForm.validate().then((success) => {
        if (success) {
          this.$refs.formConfirmation.confirm();
        }
      });
    },
    // submit() {
    //     this.loading = true;
    //     ChatChannelRepository.assign(this.data)
    //         .then((response) => {
    //             this.hide();
    //             this.$emit("success");
    //         })
    //         .catch((error) => {
    //             if (error.response?.status == 422) {
    //                 this.$refs.assignOperatorForm.setErrors(
    //                     error.response?.data?.validate
    //                 );
    //             }
    //         })
    //         .then(() => {
    //             this.loading = false;
    //         });
    // },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
